import cpfMask from './cpf';
import cnpjMask from './cnpj';

// 000.000.000-00
// 00.000.000/0000-00
const mask = function (value) {
    const sanitized = value.replace(/\D/g, '');

    if (sanitized.length > 11) {
        return cnpjMask.mask;
    }

    return cpfMask.mask;
};

export default {
    mask: mask,
    guide: false,
    keepCharPositions: true,
    placeholderChar: '\u2000',
};
